<template>
  <v-app>
    <NavBar />

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import NavBar from "./components/NavBar.vue";

export default {
  name: "App",

  components: {
    NavBar
  }
};
</script>


<style>
.rubikFont {
  font-family: 'Mansalva', cursive !important; 
}
</style>
